import { useAuth } from 'src/app/hooks/auth/auth.hook'
import { useUsersQuery, useNotificationBellNscSummaryQuery, useGetNcsNotificationsQuery, useSetNcsNotificationReadMutation, useSetNcsNotificationsReadMutation } from 'src/api/api.generated'
import useErrorSnackBar from 'src/app/hooks/error-snack-bar/error-snack-bar'
import { MAX_DAYS_NOTIFICATION, NotificationBellType, getNotificationType } from './notification-bell.type'
import { differenceInDays } from 'date-fns'

export function NotificationBellCrud({ propertyId, tenantId, open }: { propertyId: string; tenantId: string; open: boolean }) {
  const showError = useErrorSnackBar()
  const { auth } = useAuth()
  const tsId = auth.isAuthenticated ? auth.id : undefined
  const { data: usersData, loading: userLoading } = useUsersQuery({
    variables: {
      filter: {
        propertyId,
        tenantId,
        tsId: tsId,
      },
    },
    skip: !tsId || !propertyId || !tenantId,
    onError: showError,
  })

  const userId = usersData?.users?.[0]?.id

  const { data: notificationSummeryData, loading: notificationSummeryLoading } = useNotificationBellNscSummaryQuery({
    variables: {
      propertyId,
      tenantId,
      userId: userId ?? '',
    },
    skip: !userId,
    onError: showError,
  })

  const { data: notificationsData, loading: notificationLoading } = useGetNcsNotificationsQuery({
    variables: {
      propertyId,
      tenantId,
      userId: userId ?? '',
    },
    skip: !userId || !open,
    onError: showError,
  })

  const [setReadNotification] = useSetNcsNotificationReadMutation({
    onError: showError,
    refetchQueries: ['GetNcsNotifications', 'NotificationBellNscSummary'],
  })

  const [setAllReadNotification] = useSetNcsNotificationsReadMutation({
    onError: showError,
    refetchQueries: ['GetNcsNotifications', 'NotificationBellNscSummary'],
  })

  const notifications: NotificationBellType[] = (notificationsData?.getNcsNotifications ?? [])
    .filter((notification) => {
      if (!notification.createdDate) return false

      return differenceInDays(new Date(), new Date(notification.createdDate)) < MAX_DAYS_NOTIFICATION
    })
    .map((notification) => {
      const { type, title } = getNotificationType(notification?.notification?.title ?? '')

      return {
        ...notification,
        type,
        notification: {
          ...(notification?.notification ?? {}),
          title,
        },
      }
    })
  const notificationSummery = notificationSummeryData?.getNcsNotificationsSummary?.[0]

  return {
    loading: userLoading || notificationSummeryLoading || notificationLoading,
    notifications,
    notificationUnread: notificationSummery?.unread ?? 0,
    userId,
    setReadNotification,
    setAllReadNotification,
  }
}
